module.exports = __webpack_public_path__ + "img/wygodni-polecaja.ed880e08.svg";